import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {Ref, ref} from 'vue';

export class EditorNetworkStoreControllerClass {
	private static _instance: EditorNetworkStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorNetworkStoreControllerClass());
	}

	private constructor() {}

	private _node_ids_being_moved: Ref<Dictionary<boolean>> = ref({});

	// getters
	node_ids_being_moved(): Readonly<Dictionary<boolean>> {
		return this._node_ids_being_moved.value;
	}

	// mutations
	set_node_ids_being_moved(ids: CoreGraphNodeId[]) {
		for (let id of ids) {
			this._node_ids_being_moved.value[id] = true;
		}
	}
	reset_node_ids_being_moved() {
		const ids = Object.keys(this._node_ids_being_moved.value);
		for (let id of ids) {
			delete this._node_ids_being_moved.value[id];
		}
	}
}

export const EditorNetworkStoreController = EditorNetworkStoreControllerClass.instance();
